import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import { STATES } from "../data/stateBasedResets";
import { useAuth } from "../lib/auth-context";
import { ArrowRight, Lock } from "lucide-react";

const StateSelector = () => {
  const navigate = useNavigate();
  const { isPro } = useAuth();
  const [picked, setPicked] = useState(null);

  const onContinue = () => {
    if (!isPro) return;
    if (!picked) return;
    navigate(`/?state=${picked}`);
  };

  return (
    <div className="app-shell" data-testid="state-selector-page">
      <Header />
      <section className="px-6 pt-2 pb-6">
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#234B38]">Before You Begin</p>
        <h2
          className="text-3xl font-medium text-[#1A2E24] mt-1 leading-tight"
          style={{ fontFamily: "Outfit, sans-serif" }}
        >
          How does today land?
        </h2>
        <p className="text-sm text-[#5C7568] mt-2">
          {isPro
            ? "Pick the state closest to now. Your reset will be tailored to it."
            : "State selection is a Pro feature. Free users get a universal reset every day."}
        </p>

        <div className="mt-6 space-y-3">
          {STATES.map((s) => {
            const active = picked === s.id;
            return (
              <button
                key={s.id}
                type="button"
                data-testid={`state-${s.id}`}
                aria-disabled={!isPro}
                disabled={!isPro}
                onClick={() => setPicked(s.id)}
                className={`w-full text-left rounded-3xl border p-5 transition-all flex items-center gap-4 ${
                  active
                    ? "bg-[#234B38] text-white border-[#234B38] shadow-lg"
                    : isPro
                    ? "bg-white border-[#E2EBE6] hover:-translate-y-0.5 hover:shadow-md"
                    : "bg-[#FDFBF7] border-[#E2EBE6] cursor-not-allowed opacity-80"
                }`}
              >
                <span className="text-3xl shrink-0">{s.emoji}</span>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <h3
                      className={`text-base font-medium ${active ? "text-white" : "text-[#1A2E24]"}`}
                      style={{ fontFamily: "Outfit, sans-serif" }}
                    >
                      {s.label}
                    </h3>
                    {!isPro && <Lock className="w-3 h-3 text-[#5C7568]" />}
                  </div>
                  <p className={`text-sm mt-0.5 ${active ? "text-white/85" : "text-[#5C7568]"}`}>
                    {s.description}
                  </p>
                </div>
              </button>
            );
          })}
        </div>

        {isPro ? (
          <button
            onClick={onContinue}
            disabled={!picked}
            data-testid="state-continue-btn"
            className="mt-6 w-full rounded-full bg-[#234B38] hover:bg-[#1A382A] disabled:opacity-50 text-white py-4 font-medium flex items-center justify-center gap-2 transition-colors"
          >
            Begin reset <ArrowRight className="w-4 h-4" />
          </button>
        ) : (
          <button
            onClick={() => navigate("/profile")}
            data-testid="state-upgrade-btn"
            className="mt-6 w-full rounded-full bg-[#234B38] hover:bg-[#1A382A] text-white py-4 font-medium"
          >
            Unlock state selector
          </button>
        )}
      </section>
    </div>
  );
};

export default StateSelector;
